(function () {
  function getClosestIndex(track, cards) {
    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    cards.forEach(function (card, index) {
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(cardCenter - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initScenarioCarousel() {
    var track = document.querySelector('.ter-mooka-scenarios__grid');
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-ter-scenario-dot]'));

    if (!track || !dots.length) {
      return;
    }

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ter-scenario-card]'));
    var ticking = false;

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function updateActive() {
      ticking = false;
      setActive(getClosestIndex(track, cards));
    }

    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActive);
      }
    }, { passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (cards[index]) {
          cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    updateActive();
  }

  function initProductCarousel() {
    var track = document.querySelector('[data-ter-product-track]');
    var status = document.querySelector('[data-ter-product-status]');
    var previous = document.querySelector('[data-ter-product-prev]');
    var next = document.querySelector('[data-ter-product-next]');

    if (!track || !status || !previous || !next) {
      return;
    }

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ter-product-card]'));
    var ticking = false;

    function updateActive() {
      ticking = false;
      var activeIndex = getClosestIndex(track, cards);
      status.textContent = (activeIndex + 1) + ' / ' + cards.length;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    }

    function scrollToCard(index) {
      var activeIndex = getClosestIndex(track, cards);
      var targetIndex = typeof index === 'number' ? index : activeIndex;
      var target = cards[Math.max(0, Math.min(cards.length - 1, targetIndex))];

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActive);
      }
    }, { passive: true });

    previous.addEventListener('click', function () {
      scrollToCard(getClosestIndex(track, cards) - 1);
    });

    next.addEventListener('click', function () {
      scrollToCard(getClosestIndex(track, cards) + 1);
    });

    updateActive();
  }

  initScenarioCarousel();
  initProductCarousel();
})();
